define('SuiteDynamics.ImagesAltText.Entrypoint',
	[
		'Home.View',
		'underscore',
		'Utils',
		'jQuery'
	],
	function (
		HomeView,
		_,
		Utils,
		jQuery
	)
{
	'use strict';

	HomeView.prototype.initSlider = function initSlider() {
		Utils.initBxSlider(this.$('[data-slider]'), {
			nextText: '<a class="home-gallery-next-icon"></a>',
			prevText: '<a class="home-gallery-prev-icon"></a>',
			onSliderLoad: function () {
				jQuery('.bx-pager-link').attr('type', 'button');
			},
			onSlideAfter: function () {
				jQuery('.bx-pager-link').attr('type', 'button');
			}
		});
	}

	return  {
		mountToApp: function mountToApp (container) {
		}
	};
});
